// api.ts

import axios from 'axios';
const { server } = (window as any).config

const api = axios.create({
  baseURL: server,
  timeout: 30000,
  withCredentials: true,
});

api.interceptors.request.use(
  (request) => {
    // Add auth headers here if needed
    // const token = localStorage.getItem('token');
    // if (token) {
    //   request.headers.Authorization = `Bearer ${token}`;
    // }

    return request;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Unauthorized');
      // Optional: redirect to login
    }

    const message =
      error?.response?.data?.message ||
      error?.response?.data ||
      error?.message ||
      'Unexpected API error';

    return Promise.reject({
      ...error,
      message,
    });
  },
);

export default api;
